import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickSingleQuery } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IMemberBooks } from "./routeType";

const { key, getPath } = getApi("members.books.get");

type IExtractedRouteType = IMemberBooks["bookSingleRetrieve"];

export type IGetMemberBook = IPickSingleQuery<IExtractedRouteType>;

const getMemberBook: Fetcher<
  IGetMemberBook["response"],
  IGetMemberBook["variables"]
> = ({ memberId, bookId, ...params }) => {
  return axiosClient.get(getPath({ memberId, bookId }), { params });
};

export const useGetMemberBook = createQuery({
  queryKey: [key],
  fetcher: getMemberBook,
});
